import {black, green, grey, red, white, whites} from './colors'

const theme = {
    borderRadius: 12,
    breakpoints: {
        mobile: 400,
    },
    color: {
        black,
        grey,
        c074c52: "#074C52",
        c1CA17E: "#1CA17E",
        cF7F8FC:'#F7F8FC',
        primary: {
            light: red[200],
            main: red[500],
        },
        secondary: {
            main: green[500],
        },
        white,
        whites

    },
    siteWidth: 1200,
    spacing: {
        1: 4,
        2: 8,
        3: 16,
        4: 20,
        5: 32,
        6: 48,
        7: 64,
    },
    topBarSize: 72
};

export default theme
